<div class="page-title">
    <div class="title-content">
        <ng-content></ng-content>
    </div>
    <div class="scroll-box">
        <span class="scroll-text">Görgess le és tudj meg többet</span>
        <div class="scroller-bar"></div>
    </div>
</div>